import { Object3D } from "three";
import { BitObject3D, World } from "../threeMain";
import { addComponent, defineQuery, enterQuery, exitQuery, hasComponent, removeComponent } from "bitecs";
import { Object3DComponent } from "../utils/components";

const object3dQuery = defineQuery([ Object3DComponent ])
const object3dQueryExit = exitQuery(object3dQuery);
export default function bitObjectSystem(world: World){
  object3dQueryExit(world).forEach((eid : number) => {
    const prevObject = eid != undefined ? world.eid2obj.get(eid) : null;
    if(prevObject){
      world.eid2obj.delete(eid);
    };
  });
}

export function setObject3dComponent(world: World, eid: number, obj: BitObject3D){
  if(obj.eid) {
    const prevEid = obj.eid;
    const prevObject = prevEid != undefined ? world.eid2obj.get(prevEid) : null;
    if(prevObject && prevObject == obj){
      if(hasComponent(world, Object3DComponent, prevEid)) removeComponent(world, Object3DComponent, prevEid)
      world.eid2obj.delete(eid);
    };
  }
  world.eid2obj.set(eid, obj);
  obj.eid = eid;
  addComponent(world, Object3DComponent, eid)
}